import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ConfirmationPersonal from './ConfirmationPersonal';
import { getInvestorInformation } from 'store/features/investors/actions';
import { AppDispatch, RootState } from 'store/types';

const mapStateToProps = (state: RootState) => {
  return ({
    data: state.investor,
    firstname: state.investor.firstname || state.account.firstname,
    lastname: state.investor.lastname || state.account.lastname,
    birthday: state.investor.birthday,
    birthPlace: state.investor.birthPlace,
    address: state.investor.address,
    zipCode: state.investor.zipCode,
    city: state.investor.city,
    country: state.investor.country,
    phone: state.investor.phone,
    gender: ((state.investor.gender === '') ? 'Autre' : state.investor.gender) || 'Monsieur',
    societyId: state.society.id,
    investorInformation: state.investor.fetch.status,
    wantInvestBySociety: window.sessionStorage.getItem('from_company') === 'true',
  })
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ getInvestorInformation }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPersonal);
